import React from "react";

export const useImportProduct = () => {
  const [data, setData] = React.useState<object | undefined>();
  return { data, setData };
};
